var cubigoAppVersion={build:'266'};

var deviceInformation = {
    id: null
};
